
<script type="text/babel">
// import langSets from './dataMap/langSets'
import apiConfig from '../../config/api.config.js'
import dateFunc from '@/utils/dateFunc'
import moment from 'moment'
import EventCard from '@/components/EventCard.vue'
import fcheader from '@/components/header'
// 出力
import dialog from '@/components/Dialog'
import { mapState } from 'vuex'
export default {
  props: {
    events: { // events will be displayed on calendar
      type: Array,
      default: () => []
    },
    shiftInfoList: {
      type: Array,
      default: () => []
    },
    locale: {
      type: String,
      default: 'en'
    },
    firstDay: {
      type: Number | String,
      validator (val) {
        let res = parseInt(val)
        return res >= 0 && res <= 6
      },
      default: 0
    },
    isCreateNewEvent: {
      type: Boolean,
      default: true
    }
  },
  components: {
    'event-card': EventCard,
    'fc-header': fcheader,
    'v-dialog': dialog,
    apiConfig
  },
  mounted () {
    this.emitChangeMonth(this.currentMonth)
  },
  data () {
    return {
      // 点击日历event隐藏出力按钮
      isEventDsiplay: true,
      // 是否出力，默认为false
      isPrint: false,
      checkList: [],
      // 表标题栏 是否全选出力
      isSelectAll: false,
      // 出力Dialog
      showPrintDialog: false,
      dialogPrintOption: {
        showNo: true,
        text: 'データをダウンロードします。<br/>よろしいですか？',
        cancelButtonText: 'キャンセル',
        confirmButtonText: '実行'
      },
      title: '全員 (スケジュール)',

      currentMonth: moment().startOf('month'),
      isLismit: true,
      eventLimit: 4,
      showMore: false,
      morePos: {
        top: 0,
        left: 0
      },
      selectDay: {},
      weeks: ['日', '月', '火', '水', '木', '金', '土'],
      isCalendar: false,
      shiftMovementStatus: [
        '業務予定',
        '業務中',
        '業務終了',
        '業務未定',
        '強制終了'
      ]
    }
  },
  computed: {
    currentDates () {
      return this.getCalendar()
    },
    ...mapState({
      // date: state => (state.yearAndMonth).substring(2)
      remunerationDate: state => state.yearAndMonth
    })
  },
  // 出力CheckList
  created: function () {
    // 出力CheckList
    for (let i = 0; i < this.shiftInfoList.length; i++) {
      this.checkList.push(false)
    }
  },
  methods: {
    emitChangeMonth (firstDayOfMonth) {
      this.currentMonth = firstDayOfMonth

      let start = dateFunc.getMonthViewStartDate(firstDayOfMonth, this.firstDay)
      let end = dateFunc.getMonthViewEndDate(firstDayOfMonth, this.firstDay)

      this.$emit('changeMonth', start, end, firstDayOfMonth)
    },
    moreTitle (date) {
      if (!date) return ''
      return moment(date).format('ll')
    },
    getCalendar () {
      // calculate 2d-array of each month
      let monthViewStartDate = dateFunc.getMonthViewStartDate(this.currentMonth, this.firstDay)
      let calendar = []

      for (let perWeek = 0; perWeek < 6; perWeek++) {
        let week = []

        for (let perDay = 0; perDay < 7; perDay++) {
          week.push({
            monthDay: monthViewStartDate.date(),
            isToday: monthViewStartDate.isSame(moment(), 'day'),
            isCurMonth: monthViewStartDate.isSame(this.currentMonth, 'month'),
            weekDay: perDay,
            date: moment(monthViewStartDate),
            events: this.slotEvents(monthViewStartDate)
          })

          monthViewStartDate.add(1, 'day')
        }

        calendar.push(week)
      }

      return calendar
    },
    slotEvents (date) {
      // find all events start from this date
      // let cellIndexArr = []
      let thisDayEvents = this.events.filter(day => {
        let st = moment(day.start)
        let ed = moment(day.end ? day.end : st)

        return date.isBetween(st, ed, null, '[]')
      })

      // sort by duration
      thisDayEvents.sort((a, b) => {
        if (!a.cellIndex) return 1
        if (!b.cellIndex) return -1
        return a.cellIndex - b.cellIndex
      })

      // mark cellIndex and place holder
      for (let i = 0; i < thisDayEvents.length; i++) {
        thisDayEvents[i].cellIndex = thisDayEvents[i].cellIndex || (i + 1)
        thisDayEvents[i].isShow = true
        if (thisDayEvents[i].cellIndex === i + 1 || i > 2) continue
        thisDayEvents.splice(i, 0, {
          title: 'holder',
          cellIndex: i + 1,
          start: date.format(),
          end: date.format(),
          isShow: false
        })
      }

      return thisDayEvents
    },
    selectThisDay (day, jsEvent) {
      this.selectDay = day
      this.showMore = true
      this.morePos = this.computePos(event.target)
      this.morePos.top -= 100
      let events = day.events.filter(item => {
        return item.isShow === true
      })
      this.$emit('moreClick', day.date, events, jsEvent)
    },
    computePos (target) {
      let eventRect = target.getBoundingClientRect()
      let pageRect = this.$refs.dates.getBoundingClientRect()
      return {
        left: eventRect.left - pageRect.left,
        top: eventRect.top + eventRect.height - pageRect.top
      }
    },
    dayClick (day, jsEvent) {
      this.$emit('dayClick', day, jsEvent)
    },
    eventClick (event, jsEvent) {
      if (!event.isShow) return

      jsEvent.stopPropagation()
      let pos = this.computePos(jsEvent.target)
      this.$emit('eventClick', event, jsEvent, pos)
    },
    showList () {
      this.isEventDsiplay = true
      this.isCalendar = false
    },
    showCalendar () {
      this.isEventDsiplay = false
      this.isCalendar = true
    },
    // 根据不同shitMovementStatus给tr上色
    chooseColor (shiftInfo) {
      if (shiftInfo.businessStatus === 2) {
        return 'bgc4'
      } else if (shiftInfo.businessStatus === 3) {
        return 'bgc10'
      } else {
        // let count = shiftInfo.shiftReservationInfos.length
        // 「運行未定」の便は「未公開」状態の場合
        // 运行未定
        if (shiftInfo.businessStatus === 1 && shiftInfo.openFlag === 0) {
          return 'bgc5'
        } else if (shiftInfo.businessStatus === 1 && shiftInfo.openFlag === 1) {
          return 'bgc1'
        }
      }
    },
    // 根据不同shitMovementStatus给td加字体和边框
    chooseFontAndTrborder (shiftInfo) {
      if (shiftInfo.businessStatus === 2) {
        return 'F2-R-19 trborder3'
      } else if (shiftInfo.businessStatus === 3) {
        return 'F3-R-19 trborder4'
      } else {
        // let count = shiftInfo.shiftReservationInfos.length
        // 「運行未定」の便は「未公開」状態の場合
        // 运行未定
        if ((shiftInfo.businessStatus === 1 && shiftInfo.openFlag === 0)) {
          return 'F3-R-19 trborder1'
        } else if (shiftInfo.businessStatus === 1 && shiftInfo.openFlag === 1) {
          return 'F2-R-19 trborder2'
        }
      }
    },
    chooseFontAndTrborder2 (shiftInfo) {
      if (shiftInfo.businessStatus === 2) {
        return 'F2-R-16 trborder3'
      } else if (shiftInfo.businessStatus === 3) {
        return 'F3-R-16 trborder4'
      } else {
        // let count = shiftInfo.shiftReservationInfos.length
        // 「運行未定」の便は「未公開」状態の場合
        // 运行未定
        if ((shiftInfo.businessStatus === 1 && shiftInfo.openFlag === 0)) {
          return 'F3-R-16 trborder1'
        } else if (shiftInfo.businessStatus === 1 && shiftInfo.openFlag === 1) {
          return 'F2-R-16 trborder2'
        }
      }
    },
    chooseFontAndTrborder3 (shiftInfo) {
      if (shiftInfo.businessStatus === 2) {
        return 'F2-R-20 trborder3'
      } else if (shiftInfo.businessStatus === 3) {
        return 'F3-R-20 trborder4'
      } else {
        // let count = shiftInfo.shiftReservationInfos.length
        // 「運行未定」の便は「未公開」状態の場合
        // 运行未定
        if ((shiftInfo.businessStatus === 1 && shiftInfo.openFlag === 0)) {
          return 'F3-R-20 trborder1'
        } else if (shiftInfo.businessStatus === 1 && shiftInfo.openFlag === 1) {
          return 'F2-R-20 trborder2'
        }
      }
    },
    goDetail (shiftInfo) {
      this.$router.push({name: 'MovementShiftDetail', query: {shiftId: shiftInfo.shiftId, from: 'DriverScheduleList'}})
    },
    goback () {
      this.$router.push({name: 'DriverList'})
    },
    // “运行未定、运行予定”状态判断
    checkShiftMovementStatus (shiftInfo) {
      let movementStatus = ''
      // 「運行未定」の便は「未公開」状態の場合
      if ((shiftInfo.businessStatus === 1 && shiftInfo.openFlag === 0)) {
        movementStatus = this.shiftMovementStatus[3]
      } else if (shiftInfo.businessStatus === 1 && shiftInfo.openFlag === 1) {
        movementStatus = this.shiftMovementStatus[0]
      } else if (shiftInfo.coercionStopFlag === 1) {
        movementStatus = this.shiftMovementStatus[4]
      } else {
        movementStatus = this.shiftMovementStatus[shiftInfo.businessStatus - 1]
      }
      return movementStatus
    },
    // 一览出力
    driverSchedulePrint () {
      // this.title = '[出力]全員 (スケジュール)'
      this.isPrint = true
    },
    // 出力
    print () {
      let falseCheckList = this.checkList.filter(item => item === false)
      if (falseCheckList.length === this.checkList.length) {
        this.dialogPrintOption.text = 'スケジュールを選択してください。'
        this.dialogPrintOption.showNo = false
        this.dialogPrintOption.confirmButtonText = 'OK'
      } else {
        this.dialogPrintOption.text = 'データをダウンロードします。<br/>よろしいですか？'
        this.dialogPrintOption.showNo = true
        this.dialogPrintOption.cancelButtonText = 'キャンセル'
        this.dialogPrintOption.confirmButtonText = '実行'
      }
      this.showPrintDialog = true
      this.$refs.printDialog.confirm().then(() => {
        if (falseCheckList.length !== this.checkList.length) {
          let printList = []
          for (let i = 0; i < this.shiftInfoList.length; i++) {
            if (this.checkList[i]) {
              printList.push(this.shiftInfoList[i])
            }
          }
          console.log(printList)
          this.$axios.post('driver/exportDriverScheduleCsv', printList, {responseType: 'arraybuffer'}).then((res) => {
            let fileName = '全員スケジュール.csv'
            let blob = new Blob([res.data], { type: 'application/x-xls' })
            if (window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName)
            } else {
              var link = document.createElement('a')
              link.href = window.URL.createObjectURL(blob)
              link.download = fileName
              link.click()
              window.URL.revokeObjectURL(link.href)
            }
          }).catch(error => {
            console.log(error)
            let dialogPrintOption = {
              showNo: false,
              text: '予期せぬエラーが発生しました。',
              confirmButtonText: 'OK'
            }
            this.dialogPrintOption = dialogPrintOption
            this.showPrintDialog = true
            this.$refs.printDialog.confirm().then(() => {
              this.showPrintDialog = false
            })
          })
        }
        this.showPrintDialog = false
      }).catch(() => {
        this.showPrintDialog = false
      })
    },
    cancelPrint () {
      this.title = '全員 (スケジュール)'
      this.isPrint = false
      // 清空单选框
      this.isSelectAll = true
      this.checkedAll()
    },
    // 全选
    checkedAll () {
      this.isSelectAll = !this.isSelectAll
      let checkList = []
      if (this.isSelectAll) {
        for (let i = 0; i < this.shiftInfoList.length; i++) {
          checkList.push(true)
          this.checkList = checkList
        }
      } else {
        for (let i = 0; i < this.shiftInfoList.length; i++) {
          checkList.push(false)
          this.checkList = checkList
        }
      }
    },
    chooseHeight (isPrint) {
      if (isPrint === true) {
        return 'table-container-new'
      }
    },
    goPrintRemunerationList () {
      this.dialogPrintOption.text = 'データをダウンロードします。<br/>よろしいですか？'
      this.dialogPrintOption.showNo = true
      this.dialogPrintOption.cancelButtonText = 'キャンセル'
      this.dialogPrintOption.confirmButtonText = '実行'

      this.showPrintDialog = true
      this.$refs.printDialog.confirm().then(() => {
        this.showPrintDialog = false
        this.remunerationList()
      })
        .catch(() => {
          this.showPrintDialog = false
        })
    },
    // 报酬管理出力
    remunerationList () {
      this.$axios.get('driver/queryRemunerationListSize', {params: {date: this.remunerationDate}})
        .then(response => {
          console.log(response.data.hasDataFlag)
          let hasDataFlag = response.data.hasDataFlag
          if (hasDataFlag) {
            let baseUrl = apiConfig.baseUrl
            var elemIF = document.createElement('iframe')
            elemIF.src = baseUrl + 'driver/exportDriverRemunerationExcel?date=' + this.remunerationDate
            elemIF.style.display = 'none'
            this.$refs.driverExcel.appendChild(elemIF)
          } else {
            this.dialogPrintOption.text = '出力データがありません。'
            this.dialogPrintOption.showNo = false
            this.dialogPrintOption.confirmButtonText = 'OK'
            this.showPrintDialog = true
            this.$refs.printDialog.confirm().then(() => {
              this.showPrintDialog = false
            }).catch(() => {
              this.showPrintDialog = false
            })
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    driverAllExcelReport () {
      this.dialogPrintOption.text = 'データをダウンロードします。<br/>よろしいですか？'
      this.dialogPrintOption.showNo = true
      this.dialogPrintOption.cancelButtonText = 'キャンセル'
      this.dialogPrintOption.confirmButtonText = '実行'

      this.showPrintDialog = true
      this.$refs.printDialog.confirm().then(() => {
        this.showPrintDialog = false
        this.downLoadDriverAllExcelReport()
      })
        .catch(() => {
          this.showPrintDialog = false
        })
    },
    downLoadDriverAllExcelReport () {
      this.$axios.get('driver/queryDriverAllExcelReportSize', {params: {date: this.remunerationDate}})
        .then(response => {
          let hasDataFlag = response.data.hasDataFlag
          if (hasDataFlag) {
            let baseUrl = apiConfig.baseUrl
            var elemIF = document.createElement('iframe')
            elemIF.src = baseUrl + 'driver/driverAllExcelReport?date=' + this.remunerationDate
            elemIF.style.display = 'none'
            // document.body.appendChild(elemIF)
            this.$refs.driverExcel.appendChild(elemIF)
          } else {
            this.dialogPrintOption.text = '出力データがありません。'
            this.dialogPrintOption.showNo = false
            this.dialogPrintOption.confirmButtonText = 'はい'
            this.showPrintDialog = true
            this.$refs.printDialog.confirm().then(() => {
              this.showPrintDialog = false
            }).catch(() => {
              this.showPrintDialog = false
            })
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  filters: {
    localeWeekDay (weekday, firstDay, locale) {
      firstDay = parseInt(firstDay)
      const localMoment = moment().locale(locale)
      return localMoment.localeData().weekdaysShort()[(weekday + firstDay) % 7]
    }
  }
}

</script>

<template>
  <div ref="driverExcel" class="comp-full-calendar">
    <!-- header pick month -->
    <div class="row clearfix" style="flex:0 0 40px;position: relative;">
      <div style="position: absolute;width: 100%;">
        <strong class="name-strong F3-M-27">{{title}}</strong>
      </div>
      <div class="col-md-2 column headerleft F1-R-19" style="vertical-align: bottom;margin-left:20px">
        <input type="button" value="ドライバーリストに戻る" @click="goback()" />
      </div>
      <!-- <div class="col-md-4 column headerbtndiv" style="width:360px;margin-right:20px;"> -->
      <div class="col-md-4 column headerbtndiv" style="width:500px;margin-right:20px;">
        <button class="common-btn user-btn F2-M-19 detailed-button" style="border:0px" @click="goPrintRemunerationList"> 報酬管理出力</button>
        <button class="common-btn user-btn F2-M-19 detailed-button" style="border:0px" @click="driverAllExcelReport"> シフト出力</button>
        <button class="common-btn user-btn F2-M-19 detailed-button" style="border:0px" @click="driverSchedulePrint">一覧出力</button>
      </div>
    </div>
    <hr class="hrheader">
    <!-- br下面的日历控件 -->
    <fc-header :current-month="currentMonth" :first-day="firstDay" :locale="locale" :is-print="isPrint" @change="emitChangeMonth" style="margin-top:-10px">
      <div slot="header-left">
        <slot name="fc-header-left">
          <div class="clearfix" style="padding-left:15px;">
            <div class="left-btn col-md-6 column" @click="showList" style="border-bottom-left-radius: 10px;border-top-left-radius: 10px;"
              :style="{color:isCalendar?'rgb(204,204,204)':''}">
              <img v-show="!isCalendar" src="@/assets/button/list_button1.png" class="left-img" />
              <img v-show="isCalendar" src="@/assets/button/list_button2.png" class="left-img" />
              <span :class="isCalendar?'F9-M-19':'F1-M-19'">リスト</span>
            </div>
            <div class="left-btn col-md-6 column" @click="showCalendar" style="border-bottom-right-radius: 10px;border-top-right-radius: 10px;"
              :style="{color:isCalendar?'':'rgb(204,204,204)'}">
              <img v-show="isCalendar" src="@/assets/button/calender_button1.png" class="left-img" />
              <img v-show="!isCalendar" src="@/assets/button/calender_button2.png" class="left-img" />
              <span :class="isCalendar?'F1-M-19':'F9-M-19'">カレンダー</span>
            </div>
          </div>
        </slot>
      </div>
    </fc-header>

    <!--ShiftList-->
    <div class="col-md-12 column " style="display:flex;flex-direction: column; height: calc(100% - 130px);" v-show="!isCalendar">
      <div class="table-container" style="margin-left:0px;margin-right:0px;" :class="chooseHeight(this.isPrint)">
        <div class=" table-header" style="padding-right:10px;">
          <table>
            <thead>
              <tr class="theader F2-R-15 bgc9">
                <td v-show="isPrint" class="trborder1 bodytext td-print" style="width:3%">
                  <div style="display: flex;justify-content: center;align-items: center;padding-left:10px;height:100%">
                    <input type="checkbox" v-model="isSelectAll" style="height:20px;width:20px;margin-left:-14px;" @click='checkedAll()'>
                  </div>
                </td>
                <!-- 運行日時、便ID、便名、>氏名、フリガナ、预约情况-->
                <td class="trborder shift-move-time htd">運行日時</td>
                <td class="trborder shift-id htd">便ID</td>
                <td class="trborder shift-name htd">便名</td>
                <td class="trborder shift-driver-name htd">氏名</td>
                <td class="trborder shift-driver-kana htd">フリガナ</td>
                <td class="trborder  shift-status htd"></td>
              </tr>
            </thead>
          </table>
        </div>
        <div class="table-body scrollbar">
          <table class="table">
            <tbody>
              <tr class="contenttr bgc5h" :class="chooseColor(shiftInfo)" v-for='(shiftInfo, index) in shiftInfoList' v-bind:key="shiftInfo.shiftId">
                <td v-show="isPrint" class="trborder1 bodytext td-print" style="width:3%">
                  <div style="display: flex;justify-content: center;align-items: center;padding-left:10px;height:100%">
                    <input type="checkbox" v-model="checkList[index]" style="height:20px;width:20px;margin-left:-10px;">
                  </div>
                </td>
                <td class="bodytext shift-move-time" @click="goDetail(shiftInfo)" :class="chooseFontAndTrborder(shiftInfo)">
                  <div class="row clearfix">
                    <div v-if="shiftInfo.moveShiftTime!==null" class="col-md-6 column move-day">
                      {{shiftInfo.moveShiftTime}}
                    </div>
                    <div v-else class="col-md-6 column move-day">
                      未定
                    </div>
                    <div v-if="shiftInfo.startTime!==null" class="col-md-3 column move-start">
                      {{shiftInfo.startTime}}発
                    </div>
                    <div v-else class="col-md-3 column move-start">
                      未定
                    </div>
                    <div v-if="shiftInfo.arriveTime!==null" class="col-md-3 column move-arrive">
                      {{shiftInfo.arriveTime}}着
                    </div>
                    <div v-else class="col-md-3 column move-arrive">
                      未定
                    </div>
                  </div>
                </td>
                <td class="bodytext shift-id" @click="goDetail(shiftInfo)" :class="chooseFontAndTrborder2(shiftInfo)" style="padding-top:0px;padding-bottom:0px">
                  <div style="height: 54px;display: flex;align-items: center;">{{shiftInfo.shiftId}}</div>
                </td>
                <td class="bodytext shift-name member-name" :title="shiftInfo.title" @click="goDetail(shiftInfo)" :class="chooseFontAndTrborder(shiftInfo)">{{shiftInfo.title}}</td>
                <td class="bodytext shift-driver-name member-name" :title="shiftInfo.driverName" @click="goDetail(shiftInfo)" :class="chooseFontAndTrborder3(shiftInfo)">
                  <!-- {{shiftInfo.driverName}},openFlag:{{shiftInfo.openFlag}},运行status：{{shiftInfo.shiftMovementStatus}} -->
                  {{shiftInfo.driverName}}
                </td>
                <td class="bodytext shift-driver-kana member-name" :title="shiftInfo.driverNameKana" @click="goDetail(shiftInfo)" :class="chooseFontAndTrborder3(shiftInfo)">
                  {{shiftInfo.driverNameKana}}
                </td>
                <td style="text-align:center;border-right:none" class="bodytext shift-status" @click="goDetail(shiftInfo)" :class="chooseFontAndTrborder3(shiftInfo)">
                  {{checkShiftMovementStatus(shiftInfo)}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- body display date day and events -->
    <div class="full-calendar-body" v-show="isCalendar">
      <div class="weeks bgc8">
        <span class="week F3-R-19" v-for="dayIndex in 7" :key="dayIndex">{{ weeks[(dayIndex - 1)] }}</span>
      </div>

      <div class="dates" ref="dates">
        <div class="dates-bg">
          <div class="week-row" v-for="week in currentDates" :key="week.id">
            <div class="day-cell" v-for="(day,index) in week" :class="{'bgc12' : day.isToday,'F1-R-27' : day.isCurMonth,'F7-R-27' : !day.isCurMonth,'bgc8':index===0||index===week.length-1}"
              :key="day.id">
              <p class="day-number">{{ day.monthDay }}</p>
            </div>
          </div>
        </div>

        <!-- absolute so we can make dynamic td -->
        <div class="dates-events">
          <div class="events-week" v-for="week in currentDates" :key="week.id">
            <div class="events-day" v-for="day in week" track-by="$index" :key="day.id" :class="{'today' : day.isToday,
              'not-cur-month' : !day.isCurMonth}" @click.stop="dayClick(day.date, $event)">
              <!-- <p class="day-number">{{day.monthDay}}</p> -->
              <div class="event-box">
                <event-card :event="event" :date="day.date" :firstDay="firstDay" v-for="event in day.events" v-show="event.cellIndex <= eventLimit"
                  @click="eventClick" :key="event.id">
                  <template slot-scope="p">
                    <slot name="fc-event-card" :event="p.event"></slot>
                  </template>
                </event-card>
                <p v-if="day.events.length > eventLimit" class="more-link" @click.stop="selectThisDay(day, $event)">
                  + {{day.events[day.events.length -1].cellIndex - eventLimit}} more
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- full events when click show more -->
        <div class="more-events" v-show="showMore" :style="{left: morePos.left + 'px', top: morePos.top + 'px'}">
          <div class="more-header">
            <span class="title">{{ moreTitle(selectDay.date) }}</span>
            <span class="close" @click.stop="showMore = false">x</span>
          </div>
          <div class="more-body">
            <ul class="body-list">
              <li v-for="event in selectDay.events" :key="event.id" v-show="event.isShow" class="body-item" @click="eventClick(event, $event)">
                {{event.title}}
              </li>
            </ul>
          </div>
        </div>

        <slot name="body-card">

        </slot>
        <!-- <confirm-window></confirm-window> -->
      </div>
    </div>

        <!-- footer 出力时显示两个按钮 -->
    <div class="row clearfix footer" v-show="(isPrint&&isEventDsiplay)">
      <div class="col-md-6 column" style="margin-top:20px">
        <button class="driver-button" style="float:right" @click="print">出力</button>
      </div>
      <div class="col-md-6 column" style="margin-top:20px">
        <button class="driver-button" style="float:left" @click="cancelPrint">キャンセル</button>
      </div>
    </div>
    <v-dialog v-show="showPrintDialog" :dialog-option="dialogPrintOption" ref="printDialog"></v-dialog>
  </div>
</template>

<style lang="scss" scoped>@import "../assets/css/C00.css";
.name-strong {
  font-size: 30px;
}

.hrheader {
  background-color: rgb(148, 148, 148);
  height: 1px;
  width: 500px;
}

.headerbtndiv {
  display: flex;
  flex-direction: row;
  float: right; // width: 420px;想要按钮固定式可以设置该div的宽度
}

.headerleft {
  width: 300px;
  background: url(../assets/button/back_button.png) no-repeat 10px center;
}

.headerleft input {
  float: left;
  border: none;
  background: none;
  line-height: 40px;
  width: 100%;
  text-align: left;
  text-indent: 30px; // font-size: 20px;
}

.comp-full-calendar {
  // font-family: "elvetica neue", tahoma, "hiragino sans gb";
  padding-top: 20px;
  padding-bottom: 20px;
  background: #fff;
  max-width: 100%; //min-width: 1000px;
  margin: 0 auto;
  ul {
    margin: 0;
    padding: 0;
  }
  display: flex;
  flex-direction: column;
  height: calc(100% - 100px);
}

.left-btn {
  height: 50px;
  width: 45%;
  border-radius: 10px;
  background: linear-gradient(#DCDCDC, #ffffff);
  border: 0px;
  font-size: 20px;
  padding: 5px;
  text-align: left;
  padding-left: 10px;
}

.user-btn {
  float: right;
  margin-right: 10px;
  flex: 1;
  width: auto !important;
}

.full-calendar-body {
  margin-top: 8px;
  .weeks {
    display: flex;
    border-top: 1px solid #9D9D9D;
    border-bottom: 1px solid #9D9D9D;
    border-left: 1px solid #9D9D9D;
    background-color: #F0F0F0;
    .week {
      padding-top: 3px;
      flex: 1;
      text-align: center;
      border-right: 1px solid #9D9D9D;
      height: 3.5vh;
      font-size: 18px;
    }
  }
  .dates {
    position: relative;
    .week-row {
      // width: 100%;
      // position:absolute;
      border-left: 1px solid #9D9D9D;
      display: flex; // height: 108px;
      .day-cell {
        flex: 1; // min-height: 110px;
        padding: 4px;
        border-right: 1px solid #9D9D9D;
        border-bottom: 1px solid #9D9D9D;
        height: 10.7vh;
        .day-number {
          text-align: right;
          font-size: 25px;
        }
        @media screen and (max-device-width: 1480px) {
          .day-number {
            font-size: 20px;
          }
        }
        &.today {
          background-color: #DCDCDC;
        }
        &.not-cur-month {
          .day-number {
            color: #8E8E8E;
          }
        }
      }
    }
    .dates-events {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      .events-week {
        display: flex;
        .events-day {
          cursor: pointer;
          flex: 1;
          min-height: 80%;
          overflow: hidden;
          text-overflow: ellipsis;
          height: 10.7vh;
          .day-number {
            text-align: right;
            opacity: 0;
          }
          &.not-cur-month {
            .day-number {
              color: rgba(0, 0, 0, .24);
            }
          }
          .event-box {
            padding-top: 5px;
            .event-item {
              cursor: pointer;
              font-size: 12px; //background-color:#C7E6FD;
              color: rgba(0, 0, 0, .87);
              padding: 0 0 0 4px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              text-align: left;
              margin-left: 10px;
              width: 75%;
              white-space: nowrap;
              &.is-start {
                margin-left: 4px; // border-top-left-radius:4px;
                // border-bottom-left-radius:4px;
              }
              &.is-end {
                margin-right: 4px; // border-top-right-radius:4px;
                // border-bottom-right-radius:4px;
              }
              &.is-opacity {
                opacity: 0;
              }
            } // .event-item:hover{
            //   height: auto;
            //   white-space: normal;
            // }
            .more-link {
              cursor: pointer; // text-align: right;
              padding-left: 8px;
              padding-right: 2px;
              color: rgba(0, 0, 0, .38);
              font-size: 14px;
            }
          }
        }
      }
    }
    .more-events {
      position: absolute;
      width: 150px;
      z-index: 2;
      border: 1px solid #eee;
      box-shadow: 0 2px 6px rgba(0, 0, 0, .15);
      .more-header {
        background-color: #eee;
        padding: 5px;
        display: flex;
        align-items: center;
        font-size: 14px;
        .title {
          flex: 1;
        }
        .close {
          margin-right: 2px;
          cursor: pointer;
          font-size: 16px;
        }
      }
      .more-body {
        height: 146px;
        overflow: hidden;
        .body-list {
          height: 144px;
          padding: 5px;
          overflow: auto;
          background-color: #fff;
          .body-item {
            cursor: pointer;
            font-size: 12px;
            background-color: #C7E6FD;
            margin-bottom: 2px;
            color: rgba(0, 0, 0, .87);
            padding: 0 0 0 4px;
            height: 18px;
            line-height: 18px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}

a:link,
a:visited {
  color: #444;
  text-decoration: none;
}

td {
  width: 13%; //190px
  //white-space:normal;
}

.shift-btn {
  width: 90%;
  font-size: 16px;
  border: none;
  background-color: white;
  border-radius: 4px;
  margin: 3px;
  margin-top: 10px;
  padding: 3px;
}

//表头
.trborder {
  border-right: 1px solid rgb(190, 190, 190);
}

//运行未定
.trborder1 {
  border-right: 1px solid rgb(255, 255, 255);
}

//运行预定
.trborder2 {
  border-right: 1px solid rgb(195, 215, 230);
}

//运行中
.trborder3 {
  border-right: 1px solid rgb(140, 150, 210);
}

//运行终了
.trborder4 {
  border-right: 1px solid rgb(220, 220, 220);
}

// tr:hover {
//   background-color: rgb(110, 110, 110);
// }
.contenttr {
  height: 53px;
}

.table>tbody>tr>td {
  padding-top: 13px;
}

.tr-color1 {
  background: rgb(169, 169, 169);
}

.tr-color2 {
  background: rgb(111, 111, 111);
}

.tr-color3 {
  background: rgb(210, 210, 210);
}

.tr-color4 {
  background: rgb(235, 235, 235);
  color: rgb(148, 148, 148);
}

.person-img {
  height: 25px;
  width: 15px;
  margin-top: 5%;
}

.left-img {
  height: 90%;
  width: 20%;
  background: rgb(150, 150, 150);
  margin-right: 5px;
  float: left;
}

.htd {
  padding: 5px;
}

.shift-move-time {
  width: 24%;
}

.shift-id {
  width: 6%;
}

.shift-name {
  width: 30%;
}

.shift-driver-name {
  width: 15%;
}

.shift-driver-kana {
  width: 17%;
}

.shift-status {
  width: 8%;
}

.move-day {
  border-right: 1px solid #fff;
  text-align: center;
  padding: 0px;
  width: 48%;
}

.move-start {
  border-right: 1px solid #fff;
  text-align: center;
  padding: 0px;
}

.move-arrive {
  text-align: center;
  padding: 0px;
}

.excalmatory-mark {
  height: 20px;
  margin-left: 5px;
}

//出力
.driver-button {
  // border: 1px solid red;
  width: 60%;
  height: 50px;
  border-radius: 10px;
  background: linear-gradient(#70b6ca 50%, #48a3be 50%) !important;
  border: 0px;
  /* margin: 30px; */
  font-size: 22px;
  color: #fff;
  background-color: #717171;
}

.table-container-new {
  height: 60vh;
}

.member-name{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media screen and (max-device-width: 1480px) {
  .common-btn {
    font-size: 14px;
  }
  .left-btn {
    font-size: 16px;
  }
  .contenttr {
    font-size: 14px;
  }
  .shift-btn {
    font-size: 12px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/DriverScheduleComponent.vue